import React, { useState } from "react";
import { reactivateUser } from "../../functions/user/updateUsers";
import { useNavigate } from "react-router";

const ReactivateUserModal = ({ setReactivateUserModal, userId }) => {
  const navigate = useNavigate();

  const [message, setMessage] = useState(
    "Are you sure you want to reactivate this user?"
  );
  const [showConfirmBtn, setShowConfirmBtn] = useState(true);

  const handleClose = () => {
    setReactivateUserModal(false);
    navigate(`/usersHome`);
  };

  const confirmed = async () => {
    const result = await reactivateUser(userId);
    if (result) {
      setMessage(`Success: User reactivated.`);
      setShowConfirmBtn(false);
    } else {
      setMessage("Error: Failed to reactivate this user.");
      setShowConfirmBtn(false);
    }
  };

  return (
    <>
      <div className="modal-overlay" onClick={() => handleClose()} />
      <div className="modal-wrapper">
        <div className="modal">
          <div className="modal-header">
            <h5 className="modal-heading">Confirmation</h5>
          </div>
          <div className="modal-message">{message}</div>
          <div className="modal-btns">
            {showConfirmBtn && (
              <button className="modal-confirm-btn" onClick={() => confirmed()}>
                Confirm
              </button>
            )}
            <button className="modal-cancel-btn" onClick={() => handleClose()}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReactivateUserModal;
